export const UPDATE_ACCOUNT_INFORMATION = "/auth/api/myself"

export const UPDATE_PERSONAL_INFORMATION = "/auth/api/myself"
export const CHANGE_PASSWORD = "/auth/api/myself/reset-password"

export const FETCH_PROFILE = "/auth/api/myself"

export const APPOINTMENTS = "/api/myself/appointments"
export const APPOINTMENT = "/api/myself/appointments/:param"

export const DOWNLOAD_SCHEDULE = "/api/my-self/schedules"
